<script>
import Layout from "../layouts/main";
import PageHeader from "../components/page-header";
import moment from 'moment';
import Swal from "sweetalert2";
import Box from "./component/boxperfil";
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, Swal, moment, Box, Multiselect},
    data() {
        return {
            datosListos: false,
            title: "Inicio",
            showMetrics: false,
            items: [
                {
                    text: "Inicio",
                    href: "/"
                },
                {
                    text: "Foodtrack",
                    active: true
                }
            ],
            pedido_detalle_fields: [
                { key: "name", label: "NOMBRE", sortable: true },
                //{ key: "pivot.doblex2", label: "X2", sortable: true },
                { key: "pivot.cantidad", label: "CANT", sortable: true },
                //{ key: "ingredientes_modificados", label: "INGREDIENTES", sortable: true },
                //{ key: "ingredientes_agregados", label: "AGREGADOS", sortable: true },
                { key: "pivot.venta", label: "VALOR", sortable: true },
                { key: "pivot.comentario", label: "NOTA", sortable: true },
            ],
            getnetAmount:0,
            efectivoAmount:0,
            onlineAmount:0,
            transferenciaAmount:0,
            junaebAmount:0,
            edenredAmount:0,
            amipassAmount:0,
            totalCantidadPanesAyer:0,
            inventario: '',
            bebestible: '',
            articulos: [],
            articulos_dia: [],
            datos_hoy:{},
            articulo: {
                name: "",
                venta: 0,
                barra: "",
                sku: "",
                marca_id: '',
                medida_id: '',
                categoria_id: '',
                tipo_id: '',
                ubicacion_id: '',
                stock_minimo: 5
            },
            stock: {
                articulo: {},
                articulo_id: '',
                motivo: '',
                cliente_id: '',
                cantidad: 1,
                max: 1000,
                tipo: '1',
            },
            metodosPago: ["Efectivo", "Tarjeta", "Transferencia",'Dividido'],
            egreso: {
                nombre:'Egreso',
                // cantidad:1,
                tipo:'Arriendo',
                detalle:'',
                egreso:'$0',
            },
            tipo_egreso:[
                'Arriendo',
                'Sueldos',
                'FoodTruck',
                'Prestamos',
                'Patente',
                'Proveedor',
                'Despacho',
                'Equipamiento',
                'Comisiones',
                'Impuestos',
                'Egresos Fijos',
                'Egresos Variables',
            ],
            stock_boton: false,
            productos: [],
            marcas: {},
            canales: [],
            turnos: [],
            medidas: {},
            tipos: {},
            categorias: {},
            ubicaciones: {},
            clientes: {},
            isLoading: false,
            fileproductos: null,
            buttonDisabled: true,
            showError: false,
            producto_nuevo: false,
            historial: {},
            pedidos: [],
            pedidos_todos: [],
            mostrar_todos: true,
            pedido_detalle: [],
            pedido: this.estadoInicialPedido(),
            egreso: this.estadoInicialEgreso(),
            detalle: {
                producto: '',
                cantidad: 0,
                venta: ''
            },
            doblex2: false,
            editar_valor: false,
            valor_editar: {},
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight,
            pedidoSeleccionado: [],
            arreglo_productos:[],
            socios:[],
            socio:[],
            articuloSeleccionado: null,
            gramos: 0,
            precioKilo: 0,
            precioPorcion: 0,
        };
    },
    methods: {
        gardar_egreso(){
            try {
                this.egreso.canal_id=1
                this.egreso.estado='Finalizado'
                this.egreso.is_egreso='1'
                this.egreso.egreso = this.getMontoEgresoNumero('egreso')
                this.isLoading = true
                axios.post('/api/pedidos', this.egreso).then(res => {
                    console.log('Egreso created:', res.data.pedido);
                    this.get_data()
                    this.isLoading = false
                });
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false
                this.egreso = this.estadoInicialEgreso()
                this.cerrar_modal('modal_egreso');
            }
        },
        filtro_productos(){
            this.productos.filter(p=> 
                (p.disponible=='1' && p.local=='1' && this.pedido.canal.name=='Local')).forEach(element => {
                this.arreglo_productos.push(element);
            });
            return this.arreglo_productos
        },
        ver_modal_impresora(pedido){
            this.pedidoSeleccionado = pedido;
            console.log(this.pedidoSeleccionado)
            this.$refs['modal_imresora'].show();
            setTimeout(() => {
                this.imprimir();
            }, 100);
        },
        imprimir() {
            const contenido = this.$refs.contenidoPedido.innerHTML;
            const ventanaImpresion = window.open('', '', 'width=800,height=500');
            ventanaImpresion.document.write('<html><head></head><body>');
            ventanaImpresion.document.write(contenido);
            ventanaImpresion.document.write('<center><span class="logo-lg"><img src="/images/logos/LogoGris.webp" alt="" height="50" class="logo-img"></span></center>');
            ventanaImpresion.document.write('</body></html>');
            ventanaImpresion.document.close();
            ventanaImpresion.focus();
            ventanaImpresion.print();
            ventanaImpresion.close();
            this.$refs['modal_imresora'].hide();
        },
        formatNumber(num) {
            if(true){
                return num ? num.toLocaleString("es-CL", {style: "currency", currency: "CLP"}) : null;
            }else{
                return Math.round(num)
            }
        },
        formatNumberZero(num) {
            const value = parseInt(num, 10) || 0;
            return value.toLocaleString("es-CL", { style: "currency", currency: "CLP" });
        },
        normalizarNumeroMoneda(valor) {
            const limpio = String(valor ?? '').replace(/\D/g, '');
            return parseInt(limpio, 10) || 0;
        },
        formatearMonedaSinDecimales(valor) {
            const numero = parseInt(valor, 10) || 0;
            return `$${numero.toLocaleString('es-CL')}`;
        },
        handleMontoEgresoInput(campo = 'egreso') {
            const numero = this.normalizarNumeroMoneda(this.egreso[campo]);
            this.$set(this.egreso, campo, numero === 0 ? '' : this.formatearMonedaSinDecimales(numero));
        },
        handleMontoEgresoFocus(campo = 'egreso') {
            const numero = this.normalizarNumeroMoneda(this.egreso[campo]);
            if (numero === 0) {
                this.$set(this.egreso, campo, '');
            }
        },
        handleMontoEgresoBlur(campo = 'egreso') {
            const numero = this.normalizarNumeroMoneda(this.egreso[campo]);
            this.$set(this.egreso, campo, this.formatearMonedaSinDecimales(numero));
        },
        getMontoEgresoNumero(campo = 'egreso') {
            return this.normalizarNumeroMoneda(this.egreso[campo]);
        },
        selectCanal(canal) {
        this.pedido.canal = canal;
        this.pedido.canal_id = canal.id;
        this.productos_porcanal=this.productos.filter(p=> (p.disponible=='1' && p.local=='1' && this.pedido.canal.name=='Local'))
                //|| 
                // (p.disponible=='1' && p.pedidosYa=='1' && this.pedido.canal.name=='PedidosYa')|| 
                // (p.disponible=='1' && p.WhatsApp=='1' && this.pedido.canal.name=='WhatsApp')|| 
                // (p.disponible=='1' && p.UberEats=='1' && this.pedido.canal.name=='UberEats'))
                
        },
        formattedDate(date) {
            let res = moment(date).format('DD-MM-YYYY h:mm:ss A')
            if (res != 'Fecha inválida') {
                return res;
            } else {
                return false
            }
        },
        calculateTimeDifference(time1, time2) {
            const format = 'HH:mm:ss';
            const momentTime1 = moment(time1, format);
            const momentTime2 = moment(time2, format);
            const duration = moment.duration(momentTime2.diff(momentTime1));
            const hours = Math.floor(duration.asHours());
            const minutes = duration.minutes();
            const seconds = duration.seconds();
            if (hours > 0) {
                return `${hours} horas, ${minutes} minutos y ${seconds} segundos`;
            } else {
                return `${minutes} minutos y ${seconds} segundos`;
            }
        },
        calcula_valor() {
            let adicional = this.articulos
                .filter(ingrediente => this.detalle.producto.ing_adicionales.includes(ingrediente.id))
                .reduce((total, ingrediente) => total + (parseInt(ingrediente.venta, 10) || 0), 0);
            let adicionalB = this.articulos
                .filter(ingrediente => [this.bebestible].includes(ingrediente.id))
                .reduce((total, ingrediente) => total + (parseInt(ingrediente.venta, 10) || 0), 0);

            // Calcular el valor total del pedido
            let base = this.doblex2 ? parseInt(this.detalle.producto.ventax2, 10) || 0 : parseInt(this.detalle.producto.venta, 10) || 0;
            let cantidad = parseFloat(this.detalle.cantidad);
            if (isNaN(cantidad) || cantidad <= 0) {
                return 0;
            }
            let total = 0;
            //console.log(this.detalle.producto);
            const art = this.medidas.find(m => m.id === this.detalle.producto.articulos[0].medida_id);
            switch (art.name) {
                case 'Kilogramo - Gramos':
                    // Precio base por KG, cantidad ingresada en gramos
                    total = (base  + adicional + adicionalB )* (cantidad/1000);
                    break;
                case 'Litros - Mililitros':
                    // Precio base por L, cantidad ingresada en mililitros
                    total = (base + adicional + adicionalB) * (cantidad/1000);
                    break;
                case 'Unidad':
                default:
                    // Precio por unidad (lo que ya tenías)
                    total = (base + adicional + adicionalB) * cantidad;
                    break;
            }
            return total;
            //return (base + adicional + adicionalB) * cantidad;
        },
        obtenerMedidaProducto(producto) {
            let medidaId = producto?.articulos?.[0]?.medida_id
                || producto?.medida_id
                || producto?.medida?.id
                || null;

            if (!medidaId && Array.isArray(this.productos)) {
                const prod = this.productos.find(p => String(p.id) === String(producto?.id));
                medidaId = prod?.articulos?.[0]?.medida_id
                    || prod?.medida_id
                    || prod?.medida?.id
                    || null;
            }

            const medidas = Array.isArray(this.medidas) ? this.medidas : Object.values(this.medidas || {});
            if (!medidaId || !Array.isArray(medidas)) {
                return null;
            }
            return medidas.find(m => String(m.id) === String(medidaId)) || null;
        },
        unidadCantidadProducto(producto) {
            const medida = this.obtenerMedidaProducto(producto);
            if (!medida) return '';
            if (medida.name == 'Kilogramo - Gramos') return 'gr';
            if (medida.name == 'Litros - Mililitros') return 'ml';
            if (medida.name == 'Unidad') return 'un';
            return '';
        },
        formatearCantidadConUnidad(cantidad, producto) {
            const unidad = this.unidadCantidadProducto(producto);
            return unidad ? `${cantidad} ${unidad}` : `${cantidad}`;
        },
        unidadPrecioProducto(producto) {
            const medida = this.obtenerMedidaProducto(producto);
            if (!medida) return '';
            if (medida.name == 'Kilogramo - Gramos') return 'kg';
            if (medida.name == 'Litros - Mililitros') return 'L';
            if (medida.name == 'Unidad') return 'unidad';
            return '';
        },
        esProductoUnidad(producto) {
            const medida = this.obtenerMedidaProducto(producto);
            return medida?.name == 'Unidad';
        },
        stockDisponibleArticulo(articuloId) {
            const articulo = this.articulos.find(a => String(a.id) === String(articuloId));
            const stock = parseFloat(articulo?.stock);
            return isNaN(stock) ? 0 : Math.max(stock, 0);
        },
        maximoCantidadProducto(producto) {
            if (!producto || !Array.isArray(producto.articulos) || producto.articulos.length === 0) {
                return null;
            }

            let maximo = Infinity;
            producto.articulos.forEach(art => {
                const porcion = parseFloat(art?.pivot?.porcion ?? 1) || 1;
                const stockBase = this.stockDisponibleArticulo(art.id);
                const medida = this.obtenerMedidaProducto(art);

                let disponibleEnUnidadEntrada = stockBase;
                if (medida?.name == 'Kilogramo - Gramos' || medida?.name == 'Litros - Mililitros') {
                    // El stock se maneja en Kg/L y el input se ingresa en gr/ml
                    disponibleEnUnidadEntrada = stockBase * 1000;
                }

                const maxArticulo = porcion > 0 ? (disponibleEnUnidadEntrada / porcion) : 0;
                maximo = Math.min(maximo, maxArticulo);
            });

            if (!isFinite(maximo) || maximo < 0) {
                return 0;
            }

            if (this.esProductoUnidad(producto)) {
                return Math.floor(maximo);
            }
            return Math.floor(maximo * 1000) / 1000;
        },
        normalizarCantidadDetalleInput() {
            const producto = this.detalle?.producto;
            if (!producto) return;

            let cantidad = parseFloat(this.detalle.cantidad);
            if (isNaN(cantidad)) return;

            if (this.esProductoUnidad(producto)) {
                cantidad = Math.floor(cantidad);
            }

            const maximo = this.maximoCantidadProducto(producto);
            if (maximo !== null) {
                cantidad = Math.min(cantidad, maximo);
            }

            if (cantidad < 0) {
                cantidad = 0;
            }

            this.detalle.cantidad = cantidad;
        },
        subtotalBaseItem(item) {
            const base = item?.doblex2
                ? (parseInt(item?.producto?.ventax2, 10) || 0)
                : (parseInt(item?.producto?.venta, 10) || 0);
            const cantidad = parseFloat(item?.cantidad) || 0;
            const medida = this.obtenerMedidaProducto(item?.producto);

            if (!medida) return base * cantidad;
            if (medida.name == 'Kilogramo - Gramos') return base * (cantidad / 1000);
            if (medida.name == 'Litros - Mililitros') return base * (cantidad / 1000);
            return base * cantidad;
        },
        debeMostrarSubtotalOriginal(item) {
            if (Object.prototype.hasOwnProperty.call(item, 'precio_modificado')) {
                return !!item.precio_modificado;
            }
            const subtotalOriginal = Math.round(this.subtotalBaseItem(item));
            const subtotalFinal = Math.round(parseFloat(item?.venta) || 0);
            return subtotalOriginal > 0 && subtotalOriginal !== subtotalFinal;
        },
        subtotalBasePivot(item) {
            return this.subtotalBaseItem({
                producto: item,
                cantidad: item?.pivot?.cantidad,
                doblex2: item?.pivot?.doblex2,
            });
        },
        debeMostrarSubtotalOriginalPivot(item) {
            const subtotalOriginal = Math.round(this.subtotalBasePivot(item));
            const subtotalFinal = Math.round(parseFloat(item?.pivot?.venta) || 0);
            return subtotalOriginal > 0 && subtotalOriginal !== subtotalFinal;
        },
        estadoInicialPedido() {
            return {
                clientId: '',
                producto: '',
                cantidad: 1,
                comentario: '',
                venta: 0,
                pagado: false,
                estado: 'Creado',
                turno_id: 1,
                canal: this.canales?.[0]??'', 
                canal_id: 1, 
                tipo_id: '',
                n_socio: '',
                detalle: []
            };
        },
        estadoInicialEgreso() {
            return {
                clientId: '',
                producto: '',
                cantidad: 1,
                comentario: '',
                venta: 0,
                pagado: false,
                estado: 'Creado',
                turno_id: 1,
                canal: this.canales?.[0]??'', 
                canal_id: 1, 
                tipo_id: '',
                tipo:'Arriendo',
                detalle:'',
                egreso:'$0',
            };
        },
        determinarTurnoActual() {
            let ahora = new Date();
            let horaActual = ahora.getHours();
            let minutoActual = ahora.getMinutes();
            let minutosActuales = horaActual * 60 + minutoActual;

            // Usar find en lugar de forEach para poder retornar directamente desde el método
            const turnoActual = this.turnos.find(turno => {
                let [horaIni, minIni] = turno.horario_ini.split(':').map(Number);
                let [horaFin, minFin] = turno.horario_fin.split(':').map(Number);
                let minutosIni = horaIni * 60 + minIni;
                let minutosFin = horaFin * 60 + minFin;

                if (minutosFin < minutosIni) {  // Caso de turno que cruza medianoche
                    return (minutosActuales >= minutosIni && minutosActuales <= 1440) ||
                        (minutosActuales >= 0 && minutosActuales <= minutosFin);
                } else {  // Caso normal
                    return minutosActuales >= minutosIni && minutosActuales <= minutosFin;
                }
            });

            // Retorna el id del turno si se encuentra uno, de lo contrario undefined
            return turnoActual ? turnoActual.id : undefined;
        },
        quitar_producto_de_pedido(item, index) {
            this.pedido.detalle.splice(index, 1);
            this.pedido.venta = parseInt(this.pedido.venta) - parseInt(item.venta)
        },
        cancelar_producto(){
            this.detalle = {//limpia variable
                producto: '',
                cantidad: 0,
            }
        },
        agregar_producto() {
            const cantidad = parseFloat(this.detalle.cantidad);
            if (isNaN(cantidad) || cantidad <= 0) {
                this.$toasted.error('Ingresa una cantidad válida mayor a 0');
                return;
            }
            const maximo = this.maximoCantidadProducto(this.detalle.producto);
            if (maximo !== null && maximo <= 0) {
                this.$toasted.error('No hay stock disponible para este producto');
                return;
            }
            if (maximo !== null && cantidad > maximo) {
                this.$toasted.error(`La cantidad máxima disponible es ${maximo}`);
                return;
            }
            if (this.esProductoUnidad(this.detalle.producto) && !Number.isInteger(cantidad)) {
                this.$toasted.error('Para productos por unidad, la cantidad debe ser entera');
                return;
            }
            let ing1 = this.detalle.producto.ingredientes_base
            let ing2 = this.doblex2 ? this.detalle.producto.ingredientesx2 : this.detalle.producto.ingredientes
            this.detalle.ing_base = ing1
            this.detalle.ing_modificados = ing2
            this.detalle.ing_adicionales = this.detalle.producto.ing_adicionales
            this.detalle.doblex2 = this.detalle.producto.doble
            const subtotalReal = Math.round(this.calcula_valor())
            if (this.editar_valor) {
                if (!this.detalle.venta || this.detalle.venta == '') {
                    this.detalle.venta = subtotalReal
                }
            } else {
                this.detalle.venta = subtotalReal
            }
            this.detalle.venta = Math.round(parseFloat(this.detalle.venta) || 0)
            this.detalle.subtotal_real = subtotalReal
            this.detalle.precio_modificado = this.editar_valor && this.detalle.venta !== subtotalReal
            this.detalle.producto.ing_adicionales = []//limpia variable
            if (ing1.length === ing2.length && ing1.every(element => ing2.includes(element))) {
                this.detalle.ing_modificados = ing1
            }
            this.pedido.detalle.push(this.detalle)
            this.pedido.venta = parseInt(this.pedido.venta) + parseInt(this.detalle.venta)
            this.detalle = {//limpia variable
                producto: '',
                cantidad: 0,
            }
            this.doblex2 = false
            this.editar_valor = false
        },
        confirmar_pedido() {
            // Mostrar el modal de confirmación con entradas para nombre y comentarios
            this.$refs['modal_pedido'].hide();
            Swal.fire({
                title: '<h5 class="text-primary">¡Antes de generar el pedido!</h5>', // Estilo del título con HTML
                icon: 'warning',
                showCancelButton: true,
                showDenyButton: true, // Botón adicional
                confirmButtonText: 'Confirmar',
                denyButtonText: 'Confirmar e Imprimir',
                cancelButtonText: 'Cancelar',
                focusConfirm: false,
                html: `
                    <div class="form-group">
                        <input id="nombrePedido" class="form-control mb-3" placeholder="A nombre de:" style="width: 100%;">
                    </div>
                    <div class="form-group">
                        <textarea id="comentariosPedido" class="form-control" rows="2" placeholder="Comentarios generales del pedido" style="resize: none;"></textarea>
                    </div>
                `,
                customClass: {
                    confirmButton: 'btn btn-primary',  // Botón de confirmar
                    cancelButton: 'btn btn-secondary', // Botón de cancelar
                    denyButton: 'btn btn-info',        // Botón adicional
                    popup: 'shadow-lg rounded border', // Cuadro de diálogo
                    title: 'fw-bold',                  // Título
                    content: 'text-dark'               // Contenido del mensaje
                },
                preConfirm: () => {
                    const nombre = Swal.getPopup().querySelector('#nombrePedido').value;
                    const comentarios = Swal.getPopup().querySelector('#comentariosPedido').value;

                    if (!nombre) {
                        Swal.showValidationMessage('El nombre del pedido es obligatorio');
                    }

                    return { nombre, comentarios };
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    const { nombre, comentarios } = result.value;

                    // Confirmar el pedido
                    console.log("Pedido confirmado.");
                    console.log("Nombre del pedido:", nombre);
                    console.log("Comentarios:", comentarios);

                    this.isLoading = true;
                    this.pedido.nombre = nombre;
                    this.pedido.comentario = comentarios;
                    this.generar_pedido();
                } else if (result.isDenied) {
                    // Obtener valores manualmente, ya que preConfirm no se ejecuta
                    const nombre = Swal.getPopup().querySelector('#nombrePedido').value;
                    const comentarios = Swal.getPopup().querySelector('#comentariosPedido').value;

                    if (!nombre) {
                        Swal.fire('Error', 'El nombre del pedido es obligatorio', 'error');
                        return;
                    }

                    // Confirmar e imprimir el pedido
                    console.log("Pedido confirmado e impreso.");
                    console.log("Nombre del pedido:", nombre);
                    console.log("Comentarios:", comentarios);

                    this.isLoading = true;
                    this.pedido.nombre = nombre;
                    this.pedido.comentario = comentarios;
                    this.generar_pedido_imprimir();
                } else {
                    this.$refs['modal_pedido'].show();
                }
            });
        },
        generar_pedido() {
            let pedido='';
            try {
                this.pedido.canal_id=this.pedido.canal.id
                this.isLoading = true
                axios.post('/api/pedidos', this.pedido).then(res => {
                    console.log('Order created:', res.data.pedido);
                    pedido=res.data.pedido
                    //this.fetchOrders();
                    this.get_data()
                    this.isLoading = false
                    // this.ver_modal_impresora(res.data.pedido) //imprime boleta al confirmar el pedido
                    this.ver_payment_modal(pedido);
                });
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false
                this.pedido = this.estadoInicialPedido()
                this.cerrar_modal('modal_pedido');
            }
        },
        generar_pedido_imprimir() {
            let pedido='';
            try {
                this.pedido.canal_id=this.pedido.canal.id
                this.isLoading = true
                axios.post('/api/pedidos', this.pedido).then(res => {
                    console.log('Order created:', res.data.pedido);
                    pedido=res.data.pedido;
                    let canal = this.canales.find(c => c.id == pedido.canal_id);
                    if (canal) {
                        pedido.canal_name = canal.name
                    } else {
                        pedido.canal_name = 'No Definido'
                    }
                    this.get_data()
                    this.isLoading = false
                    console.log('Imprimir:', pedido);
                    this.ver_modal_impresora(pedido) //imprime boleta al confirmar el pedido
                    this.ver_payment_modal(pedido);
                });
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false
                this.pedido = this.estadoInicialPedido()
                this.cerrar_modal('modal_pedido');
            }
        },
        pedido_pagado(pedido) {
            try {
                this.isLoading = true
                if(pedido.paymentType=='total'){
                    if(pedido.paymentMethod=='Debito' || pedido.paymentMethod=='GetNet' ){
                        pedido.getnetAmount=pedido.venta
                    }else if(pedido.paymentMethod=='Credito' || pedido.paymentMethod=='OnLine'){
                        pedido.onlineAmount=pedido.venta
                    }else if(pedido.paymentMethod=='Efectivo'){
                        pedido.efectivoAmount=pedido.venta
                    }else if(pedido.paymentMethod=='Transferencia'){
                        pedido.transferenciaAmount=pedido.venta
                    }else if(pedido.paymentMethod=='Junaeb'){
                        pedido.junaebAmount=pedido.venta
                    }else if(pedido.paymentMethod=='Edenred' || pedido.paymentMethod=='edenred'){
                        pedido.edenredAmount=pedido.venta
                    }else if(pedido.paymentMethod=='amipos' || pedido.paymentMethod=='amipass'){
                        pedido.amipassAmount=pedido.venta
                    }
                }else{
                    pedido.getnetAmount=this.getnetAmount;
                    pedido.onlineAmount=this.onlineAmount;
                    pedido.efectivoAmount=this.efectivoAmount;
                    pedido.transferenciaAmount=this.transferenciaAmount;
                    pedido.junaebAmount=this.junaebAmount;
                    pedido.edenredAmount=this.edenredAmount;
                    pedido.amipassAmount=this.amipassAmount;
                }
                axios.post('/api/pedido_pagado', pedido).then(res => {
                    console.log('Order Update:', res.data.pedido);
                    //this.fetchOrders();
                    this.get_data()
                    this.isLoading = false
                });
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false
                this.$refs.payment_modal.hide();
            }
        },
        pedido_cancelado(pedido) {
            // Mostrar el modal de confirmación
            Swal.fire({
                title: '¿Estás seguro de cancelar el pedido?',
                text: "Esta acción no se puede deshacer",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, cancelar pedido',
                cancelButtonText: 'No, volver al menú',
                customClass: {
                    confirmButton: 'btn btn-primary',  // Cambia 'btn btn-primary' por las clases CSS que desees
                    cancelButton: 'btn btn-secondary'  // Cambia 'btn btn-secondary' por las clases CSS que desees
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    // Si el usuario confirma, proceder con la cancelación del pedido
                    this.isLoading = true;
                    axios.post('/api/pedido_cancelado', pedido)
                        .then(res => {
                            console.log('Order Update:', res.data.pedido);
                            // Aquí puedes llamar a una función para actualizar los pedidos
                            this.get_data();
                            Swal.fire(
                                'Cancelado',
                                'El pedido ha sido cancelado exitosamente.',
                                'success'
                            );
                        })
                        .catch(e => {
                            console.error(e);
                            Swal.fire(
                                'Error',
                                'Ocurrió un error al cancelar el pedido. Inténtalo de nuevo más tarde.',
                                'error'
                            );
                        })
                        .finally(() => {
                            this.isLoading = false;
                        });
                }
            });
        },
        pedido_finalizado(pedido) {
            try {
                this.isLoading = true
                axios.post('/api/pedido_finalizado', pedido).then(res => {
                    console.log('Order Update:', res.data.pedido);
                    //this.fetchOrders();
                    this.get_data()
                    this.isLoading = false
                });
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false
            }
        },
        fetchOrders() {
            axios.get('/api/get_pedidos_dia')
                .then(response => {
                    this.pedidos = response.data;
                    
                    this.pedidos.forEach(pedido => {

                        let canal = this.canales.find(c => c.id == pedido.canal_id);
                        if (canal) {
                            pedido.canal_name = canal.name
                        } else {
                            pedido.canal_name = 'No Definido'
                        }
                        let turno = this.turnos.find(c => c.id == pedido.turno_id);
                        if (turno) {
                            pedido.turno_name = turno.name
                        } else {
                            pedido.turno_name = 'No Definido'
                        }
                        this.pedidos_todos = this.pedidos
                    });
                })
                .catch(error => {
                    console.error('Error fetching pedidos:', error);
                });
        },
        abrir_modal(modal) {
            if (modal == 'modal_pedido') {
                this.pedido.turno_id = this.determinarTurnoActual()
                this.pedido.canal_id = this.canales.length > 0 ? this.canales[0].id : null;
                // console.log(this.pedido)
            }
            this.$nextTick(() => {
                this.$refs[modal].show();   
            })
        },
        cerrar_modal(modal) {
            this.$nextTick(() => {
                this.$refs[modal].hide();
            })
        },
        formatearFecha(fecha) {
            fecha = new Date(fecha);
            // Formatear la fecha como deseado (por ejemplo: DD/MM/YYYY HH:mm:ss)
            const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' };
            return fecha.toLocaleDateString('es-ES', options).replace(/,/g, '');

        },
        validarCantidad() {
            if (parseInt(this.stock.cantidad) <= 0) {
                this.stock_boton = true
            } else {
                this.stock_boton = false
            }
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        get_data() {
            this.isLoading = true
            try {
                axios.get('/api/inventarios').then(res => {
                    this.articulos = res.data.datos;
                    this.articulos_dia = res.data.datos_dia;
                    this.totalCantidadPanesAyer = res.data.totalCantidadAyer;
                    this.canales = res.data.canales;
                    this.turnos = res.data.turnos;
                    this.marcas = res.data.marcas;
                    this.medidas = res.data.medidas;
                    this.ubicaciones = res.data.ubicaciones;
                    this.tipos = res.data.tipos;
                    console.log(this.tipos)
                    this.categorias = res.data.categorias;
                    this.clientes = res.data.clientes;
                    this.productos = res.data.productos;
                    this.productos.forEach(element => {
                        element.ingredientes_base = JSON.parse(element.ingredientes);
                        element.ingredientes = JSON.parse(element.ingredientes);
                        element.ingredientesx2 = JSON.parse(element.ingredientesx2);
                        element.ing_adicionales = [];
                    });
                    this.isLoading = false
                    // console.log(this.productos)
                    // console.log(this.canales)
                    this.fetchOrders();
                    // this.user.sucursal.categorizaciones.includes('CODIGODEBARRA') && this.marcas.length > 0 ? this.fields.push({ key: "barra", label: "CÓDIGO DE BARRA", sortable: true }) : '';
                    // this.user.sucursal.categorizaciones.includes('SKU') && this.marcas.length > 0 ? this.fields.push({ key: "sku", label: "SKU", sortable: true }) : '';
                    // this.user.sucursal.categorizaciones.includes('Marcas') && this.marcas.length > 0 ? this.fields.push({ key: "marca", label: "MARCA", sortable: true }) : '';
                    // this.user.sucursal.categorizaciones.includes('Categorias') && this.categorias.length > 0 ? this.fields.push({ key: "categoria", label: "CATEGORIA", sortable: true }) : '';
                    // this.user.sucursal.categorizaciones.includes('Ubicaciones') && this.ubicaciones.length > 0 ? this.fields.push({ key: "ubicacion", label: "UBICACIÓN", sortable: true }) : '';
                    // //this.fields.push({ key: "stock", label: "STOCK", sortable: false })
                    // this.fields.push({ key: "actions", label: "ACCIONES", sortable: false })
                    this.$toasted.success('Datos cargados!');
                    this.pedido.canal=this.canales?.[0]??'';
                    this.productos_porcanal=this.productos.filter(p=> p.disponible=='1' && p.local=='1');
                })
                axios.get('/api/socios').then(res => {
                    // extraemos socios y, si quisieras, cafes_canje
                    this.socios      = res.data.socios;
                    this.cafes_canje = res.data.cafes_canje;
                })
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false
                this.socio=[]
            }
        },
        formatNumber(num) {
            num = parseInt(num, 10);

            // Verificar si la conversión fue exitosa (parseInt puede devolver NaN en ciertos casos)
            if (isNaN(num)) {
                return 0;  // Retornar 0 si la conversión falla
            }
            if (num==0) {
                return '$0';  // Retornar 0 si la conversión falla
            }
            if(true){
                return num ? num.toLocaleString("es-CL", {style: "currency", currency: "CLP"}) : null;
            }else{
                return Math.round(num)
            }
        },
        ver_modal_producto(tipo, articulo) {
            if (tipo == 'nuevo') {
                this.producto_nuevo = true;
                this.articulo.name = "";
                this.articulo.venta = 0;
                this.articulo.barra = "";
                this.articulo.sku = "";
                this.articulo.marca_id = '';
                this.articulo.medida_id = '';
                this.articulo.categoria_id = '';
                this.articulo.tipo_id = '';
                this.articulo.ubicacion_id = '';
                this.articulo.stock_minimo = 5;
            } else {
                this.producto_nuevo = false;
                this.articulo = articulo
                this.articulo.stock_minimo = parseInt(articulo.stock_minimo)
            }
            this.$refs['modal_producto'].show();
        },
        guardar_valor() {
            try {
                this.isLoading = true
                axios.post('/api/editar_valor_articulo', this.valor_editar).then(res => {
                    console.log('Articulo Update:', res.data.articulo);
                    //this.fetchOrders();
                    this.get_data()
                    this.isLoading = false
                    this.$refs['editar_valor_producto'].hide();
                    this.valor_editar = {}
                });
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false
            }
        },
        update_producto() {
            if (this.articulo.name != "") {
                this.isLoading = true
                axios.put('/api/articulos/' + this.articulo.id, this.articulo).then(res => {
                    if (res.data.estado) {
                        this.articulo = res.data.articulo
                        this.get_data()
                    } else {
                        Swal.fire({
                            //position: "top-end",
                            icon: "warning",
                            title: "Error al agregar",
                            text: '',
                            showConfirmButton: true,
                            timer: 5000
                        });
                    }
                    this.isLoading = false
                })
            } else {
                Swal.fire({
                    //position: "top-end",
                    icon: "warning",
                    title: "Nombre invalido",
                    text: '',
                    showConfirmButton: true,
                    timer: 5000
                }).then((result) => {
                    this.$refs['modal_producto'].show();
                })
            }
        },
        guardar_producto() {
            if (this.articulo.name != "") {
                this.isLoading = true
                axios.post('/api/articulos', this.articulo).then(res => {
                    if (res.data.estado) {
                        this.articulo = res.data.articulo
                        this.get_data()
                    } else {
                        Swal.fire({
                            //position: "top-end",
                            icon: "warning",
                            title: "Error al agregar",
                            text: '',
                            showConfirmButton: true,
                            timer: 5000
                        });
                    }
                    this.isLoading = false
                })
            } else {
                Swal.fire({
                    //position: "top-end",
                    icon: "warning",
                    title: "Nombre invalido",
                    text: '',
                    showConfirmButton: true,
                    timer: 5000
                }).then((result) => {
                    this.$refs['modal_producto'].show();
                })
            }
        },
        editar_valor_producto(producto) {
            this.valor_editar = producto
            this.$refs['editar_valor_producto'].show();
        },
        agregar_stock(producto) {
            this.stock = {}
            this.stock_boton = false
            this.stock.articulo = producto;
            this.stock.articulo_id = producto.id;
            this.stock.motivo = '';
            this.stock.cliente_id = '';
            this.stock.cantidad = 1;
            this.stock.max = 1000;
            this.stock.tipo = '1';

            this.$refs['stock_producto'].show();
        },
        quitar_stock(producto) {
            this.stock = {}
            this.stock_boton = false
            this.stock.articulo = producto
            this.stock.articulo_id = producto.id
            this.stock.motivo = ''
            this.stock.cliente_id = ''
            this.stock.cantidad = 1
            this.stock.max = producto.ingresos - producto.egresos
            this.stock.tipo = '2'

            this.$refs['stock_producto'].show();
        },
        guardar_stock() {
            //console.log(this.stock)
            if (parseFloat(this.stock.max) < parseInt(this.stock.cantidad)) {
                Swal.fire({
                    //position: "top-end",
                    icon: "warning",
                    title: "La cantidad supera el stock actual de " + this.stock.max,
                    text: '',
                    showConfirmButton: true,
                    timer: 5000
                });
            } else if (!isNaN(parseFloat(this.stock.cantidad)) && isFinite(this.stock.cantidad)) {
                this.isLoading = true
                this.$refs['stock_producto'].hide();
                axios.post('/api/inventarios', this.stock).then(res => {
                    if (res.data.estado) {
                        this.inventario = res.data.inventario
                        this.get_data()
                    } else {
                        Swal.fire({
                            //position: "top-end",
                            icon: "warning",
                            title: "La cantidad no es valida.",
                            text: '',
                            showConfirmButton: true,
                            timer: 5000
                        });
                    }
                    this.isLoading = false
                })
            } else {
                Swal.fire({
                    //position: "top-end",
                    icon: "warning",
                    title: "La cantidad no es valida",
                    text: '',
                    showConfirmButton: true,
                    timer: 5000
                });
            }
        },
        ver_historial(articulo) {
            this.historial = articulo
            this.$refs.historial.show();
        },
        ver_pedido_detalle(pedido) {
            this.pedido_detalle = pedido
            //console.log(pedido)
            this.$refs.pedido_detalle.show();
        },
        ver_payment_modal(pedido) {
            console.log(pedido)
            this.pedido_detalle = pedido
            this.$set(this.pedido_detalle, 'paymentType', this.pedido_detalle.paymentType || 'total')
            this.$set(this.pedido_detalle, 'paymentMethod', this.pedido_detalle.paymentMethod || '')
            this.getnetAmount=0
            this.efectivoAmount=0
            this.onlineAmount=0
            this.transferenciaAmount=0
            this.junaebAmount=0
            this.edenredAmount=0
            this.amipassAmount=0
            this.$refs.payment_modal.show();
            // this.pedido_detalle.transbankAmount = 0
            // this.pedido_detalle.efectivoAmount = 0
        },
        seleccionarTipoPago(tipo) {
            this.$set(this.pedido_detalle, 'paymentType', tipo);
            if (tipo !== 'total') {
                this.$set(this.pedido_detalle, 'paymentMethod', '');
            }
        },
        seleccionarMetodoPago(metodo) {
            this.$set(this.pedido_detalle, 'paymentMethod', metodo);
        },
        onFileProductosChange(e) {
            this.fileproductos = e.target.files[0];
            this.buttonDisabled = false;
        },
        descargar_formato() {
            let url = '/csv/formato_productos.csv';
            // Abrir una nueva ventana con la URL del archivo
            window.open(url, '_blank');
        },
        uploadCsvArticulos() {
            this.isLoading = true;
            if (this.buttonDisabled) {
                return; // Si está deshabilitado, salir sin hacer nada
            }
            this.buttonDisabled = true;

            let formData = new FormData();
            formData.append('file', this.fileproductos);

            axios.post('/api/upload_csv_articulos', formData).then(res => {
                if (res.data.estado) {
                    this.$refs['csv'].hide();
                    console.log(res.data.mensaje);
                    console.log(res.data.productosCargados);
                    console.log(res.data.productosError);
                    this.get_data()
                    this.isLoading = false;
                }
            }).catch(error => {
                console.error(error);
                this.isLoading = false;
            });

            setTimeout(() => {
                // Volver a habilitar el botón después de algún tiempo (por ejemplo, 3 segundos)
                this.buttonDisabled = false;
            }, 5000);
        },
        increaseQuantity(index) {
            //if (this.pedido.detalle[index].cantidad<this.pedido.detalle[index].stock) {
            this.pedido.detalle[index].cantidad++;
            //}
        },
        decreaseQuantity(index) {
            if (this.pedido.detalle[index].cantidad > 1) {
                this.pedido.detalle[index].cantidad--;
            }
        },
        aumentarQuantity(index) {
            //if (this.pedido.detalle[index].cantidad<this.pedido.detalle[index].stock) {
            this.detalle.cantidad++;
            //}
        },
        disminuirQuantity(index) {
            if (this.detalle.cantidad > 1) {
                this.detalle.cantidad--;
            }
        },
        labelselect_cat({ name }) {
            return `${name}`
        },
        cambia_mostrar() {
            // Aquí puedes ejecutar cualquier lógica adicional cuando el checkbox cambie
            if (this.mostrar_todos) {
                this.pedidos = this.pedidos_todos
                // Ejemplo de lógica adicional cuando los campos se muestran
            } else {
                this.pedidos = this.pedidos_todos.filter(p => p.estado == 'Creado' || p.estado == 'Pagado')
                // Ejemplo de lógica adicional cuando los campos se ocultan
            }
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
            this.windowHeight = window.innerHeight;
            //console.log(this.windowWidth);
            //console.log(this.windowHeight);
        },
        customLabel(option) {
            return `${option.name}`;
            },
        onSelect(selected) {
            // Acción que ocurre cuando se selecciona un producto
            this.detalle.producto = selected;
            this.detalle.cantidad = 0;
            this.$nextTick(() => {
                if (this.$refs.inputCantidadDetalle && typeof this.$refs.inputCantidadDetalle.focus === 'function') {
                    this.$refs.inputCantidadDetalle.focus();
                }
            });
            console.log("Producto seleccionado:", selected);
            },
        limpiarCantidadDetalle() {
            if (Number(this.detalle.cantidad) === 0) {
                this.detalle.cantidad = null;
            }
        },
        restaurarCantidadDetalle() {
            if (!this.detalle.cantidad || Number(this.detalle.cantidad) <= 0) {
                this.detalle.cantidad = 0;
            }
        },
        onEnterSelect() {
            // Acción que ocurre cuando se presiona Enter
            if (this.selectedProduct) {
                this.onSelect(this.selectedProduct); // Selecciona el producto temporal si se presionó enter
            }
        },
        saveToLocalStorage() {
            // Guarda el estado de showMetrics en localStorage
            localStorage.setItem('showMetrics', this.showMetrics);
        },
        loadFromLocalStorage() {
            // Recupera el estado de showMetrics desde localStorage
            const savedValue = localStorage.getItem('showMetrics');
            this.showMetrics = savedValue === 'true'; // Convierte el string a boolean
        },
        extraerHora(fecha) {
            if (!fecha || typeof fecha !== 'string') {
                return '--:--:--'; // Mensaje por defecto si es null o no es válido
            }
            const partes = fecha.split(' ');
            return partes.length > 1 ? partes[1] : 'Hora no disponible';
            },
        nombre_medida(articulo) {
            if (articulo.medida_id == null || articulo.medida_id == '') {
                return 'No Definido';
            }else {
                const art = this.medidas.find(m => m.id === articulo.medida_id);
                if (art.name=='Kilogramo - Gramos'){
                    return 'Gramos'
                } else if (art.name=='Litros - Mililitros'){
                    return 'Mililitros'
                } else if (art.name=='Unidad'){
                    return 'Unidades'
                } 
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    mounted() {
        this.loadFromLocalStorage();
        window.addEventListener('resize', this.handleResize);
        this.totalRows = this.articulos.length;
        this.get_data()
        if(this.user.rol=='Admin'){
            axios.get("/api/get_ventas_mes").then(res => {
                if(res.data.estado){
                    this.datos_hoy.totalVentasHoy=res.data.totalVentasHoy
                    this.datos_hoy.totalVentasHoy_turnoA=res.data.totalVentasHoy_turnoA
                    this.datos_hoy.totalVentasHoy_turnoB=res.data.totalVentasHoy_turnoB
                    this.datos_hoy.totalVentasHoy_getnet=res.data.totalVentasHoy_getnet
                    this.datos_hoy.totalVentasHoy_efectivo=res.data.totalVentasHoy_efectivo
                    this.datos_hoy.totalVentasHoy_online=res.data.totalVentasHoy_online
                    this.datos_hoy.totalVentasHoy_junaeb=res.data.totalVentasHoy_junaeb
                    this.datos_hoy.totalVentasHoy_transferencia=res.data.totalVentasHoy_transferencia
                    this.datos_hoy.totalVentasHoy_edenred=res.data.totalVentasHoy_edenred
                    this.datos_hoy.totalVentasHoy_amipass=res.data.totalVentasHoy_amipass
                    this.datos_hoy.totalVentasAyer=res.data.totalVentasAyer
                    this.datos_hoy.totalVentasAyer_turnoA=res.data.totalVentasAyer_turnoA
                    this.datos_hoy.totalVentasAyer_turnoB=res.data.totalVentasAyer_turnoB
                    this.datos_hoy.totalVentasAyer_getnet=res.data.totalVentasAyer_getnet
                    this.datos_hoy.totalVentasAyer_efectivo=res.data.totalVentasAyer_efectivo
                    this.datos_hoy.totalVentasAyer_online=res.data.totalVentasAyer_online
                    this.datos_hoy.totalVentasAyer_junaeb=res.data.totalVentasAyer_junaeb
                    this.datos_hoy.totalVentasAyer_transferencia=res.data.totalVentasAyer_transferencia
                    this.datos_hoy.totalVentasAyer_edenred=res.data.totalVentasAyer_edenred
                    this.datos_hoy.totalVentasAyer_amipass=res.data.totalVentasAyer_amipass
                    this.datos_hoy.totalVentasMesActual=res.data.totalVentasMesActual
                    this.datos_hoy.totalVentasMesAnterior=res.data.totalVentasMesAnterior
                    //console.log(this.datos_hoy)
                    this.datosListos=true
                }
            }); 
        }else{
            this.datosListos=true
        }
    },
    computed: {
        detalleEsUnidad() {
            return this.esProductoUnidad(this.detalle?.producto);
        },
        detalleCantidadStep() {
            return this.detalleEsUnidad ? 1 : 0.001;
        },
        detalleCantidadMinima() {
            return this.detalleEsUnidad ? 1 : 0.001;
        },
        maxCantidadProductoActual() {
            const maximo = this.maximoCantidadProducto(this.detalle?.producto);
            return maximo === null ? undefined : maximo;
        },
        coffeeCombined() {
            let coffeeBefore=this.socio ? parseInt(this.socio.coffee_count) : 0;
            let canjeados=this.pedido.detalle
                .filter(item => item.canje) // tipo_id=4 identifica "Cafes"
                .reduce((sum) => sum + 10, 0);
            let cantidad=this.pedido.detalle
                .filter(item => item.producto.tipo_id === 4 && !item.canje) // tipo_id=4 identifica "Cafes"
                .reduce((sum, item) => sum + parseInt(item.cantidad), 0);
            let coffeeInCart=cantidad-canjeados;
            return coffeeBefore + coffeeInCart
        },
        lastMultipleAfter() {
            return Math.floor(this.coffeeCombined / 11)||0;
        },
        rows() {
            return this.articulos.length;
        },
        Valor_restante() {
            let getnetAmount = isNaN(this.getnetAmount) || this.getnetAmount < 0 ? 0 : parseInt(this.getnetAmount);
            this.getnetAmount=getnetAmount;
            let efectivoAmount = isNaN(this.efectivoAmount) || this.efectivoAmount < 0 ? 0 : parseInt(this.efectivoAmount);
            this.efectivoAmount=efectivoAmount;
            let onlineAmount = isNaN(this.onlineAmount) || this.onlineAmount < 0 ? 0 : parseInt(this.onlineAmount);
            this.onlineAmount=onlineAmount;
            let junaebAmount = isNaN(this.junaebAmount) || this.junaebAmount < 0 ? 0 : parseInt(this.junaebAmount);
            this.junaebAmount=junaebAmount;
            let transferenciaAmount = isNaN(this.transferenciaAmount) || this.transferenciaAmount < 0 ? 0 : parseInt(this.transferenciaAmount);
            this.transferenciaAmount=transferenciaAmount;
            let edenredAmount = isNaN(this.edenredAmount) || this.edenredAmount < 0 ? 0 : parseInt(this.edenredAmount);
            this.edenredAmount=edenredAmount;
            let amipassAmount = isNaN(this.amipassAmount) || this.amipassAmount < 0 ? 0 : parseInt(this.amipassAmount);
            this.amipassAmount=amipassAmount;
            let venta = isNaN(this.pedido_detalle.venta) || this.pedido_detalle.venta < 0 ? 0 : parseInt(this.pedido_detalle.venta);

            // Calcula el valor restante
            let totalPagado = getnetAmount + efectivoAmount + onlineAmount + junaebAmount + transferenciaAmount + edenredAmount + amipassAmount;
            let valorRestante = totalPagado - venta;

            // Mostrar en la consola los valores para depuración
            console.log("Valor Restante:", valorRestante);

            return valorRestante;
        },
    },
    created(){
        this.handleResize();
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <Box />
        <loading-message v-if="isLoading" />
        <div class="row">
            <div class="col-lg-12">
                <div v-if="user.rol=='Admin' && datosListos" class="card mb-3">
                    <div class="card-body">
                        <h5 class="mb-3">Resumen de ventas</h5>
                        <div class="row">
                            <div class="col-md-6 col-xl-3 mb-3 mb-xl-0">
                                <div class="border rounded p-3 h-100">
                                    <p class="text-muted mb-1">Ventas de hoy</p>
                                    <h4 class="mb-0">{{ formatNumberZero(datos_hoy.totalVentasHoy) }}</h4>
                                </div>
                            </div>
                            <div class="col-md-6 col-xl-3 mb-3 mb-xl-0">
                                <div class="border rounded p-3 h-100">
                                    <p class="text-muted mb-1">Ventas de ayer</p>
                                    <h4 class="mb-0">{{ formatNumberZero(datos_hoy.totalVentasAyer) }}</h4>
                                </div>
                            </div>
                            <div class="col-md-6 col-xl-3 mb-3 mb-xl-0">
                                <div class="border rounded p-3 h-100">
                                    <p class="text-muted mb-1">Ventas del mes actual</p>
                                    <h4 class="mb-0">{{ formatNumberZero(datos_hoy.totalVentasMesActual) }}</h4>
                                </div>
                            </div>
                            <div class="col-md-6 col-xl-3">
                                <div class="border rounded p-3 h-100">
                                    <p class="text-muted mb-1">Ventas del mes pasado</p>
                                    <h4 class="mb-0">{{ formatNumberZero(datos_hoy.totalVentasMesAnterior) }}</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--<div class="form-check mb-3" v-if="false">
                    <b-form-checkbox id="showMetrics"
                        name="showMetrics" v-model="showMetrics" @change="saveToLocalStorage">
                        Mostrar/Ocultar Métricas
                    </b-form-checkbox>
                </div>
                <div v-if="articulos_dia.length > 0 && datosListos" class="align-self-center">
                    <div class="card mb-2">
                        <div class="text-lg-center mt-2 mt-lg-0" v-if="showMetrics">
                            <h5 class="m-4 text-lg-left">Métricas ventas diarias</h5>
                            <div class="row">
                                <div class="col-2 mt-2 mb-2">
                                    <div>
                                        <p class="text-muted text-truncate">
                                            Total Waffles
                                        </p>
                                        <h4 class="bx bxs-badge" style="color: #EECC93;"></h4>
                                        <h5 class="mb-0">{{ Math.abs(tipos[0].ventasHoy) }}</h5>
                                    </div>
                                </div>
                                <div class="col-2 mt-2 mb-2">
                                    <div>
                                        <p class="text-muted text-truncate">
                                            Total Completos
                                        </p>
                                        <h4 class="fas fa-hotdog" style="color: #DEB887;"></h4>
                                        <h5 class="mb-0">{{ Math.abs(tipos[1].ventasHoy) }}</h5>
                                    </div>
                                </div>
                                <div class="col-2 mt-2 mb-2">
                                    <div>
                                        <p class="text-muted text-truncate">
                                            Total Cafe
                                        </p>
                                        <h4 class="fas fa-coffee" style="color: brown;"></h4>
                                        <h5 class="mb-0">{{ Math.abs(tipos[3].ventasHoy) }}</h5>
                                    </div>
                                </div>
                                <div class="col-2 mt-2 mb-2" v-if="user.rol=='Admin'">
                                    <div>
                                        <p class="text-muted text-truncate">
                                            Venta Turno A
                                        </p>
                                        <h4 class="fas fa-calendar-day" style="color: green"></h4>
                                        <h5 class="mb-0">{{formatNumber(datos_hoy.totalVentasHoy_turnoA)}}</h5>
                                    </div>
                                </div>
                                <div class="col-2 mt-2 mb-2" v-if="user.rol=='Admin'">
                                    <div>
                                        <p class="text-muted text-truncate">
                                            Venta Turno B
                                        </p>
                                        <h4 class="fas fa-calendar-day" style="color: green"></h4>
                                        <h5 class="mb-0">{{formatNumber(datos_hoy.totalVentasHoy_turnoB)}}</h5>
                                    </div>
                                </div>
                            </div>
                            <h5 class="m-4 text-lg-left" v-if="user.rol=='Admin'">Flujo de caja diario</h5>
                            <div class="row" v-if="user.rol=='Admin'">
                                <div class="col-2 mt-2 mb-4">
                                    <div>
                                        <p class="text-muted text-truncate mb-2">
                                            Total Efectivo
                                        </p>
                                        <h5 class="mb-0">{{formatNumber(datos_hoy.totalVentasHoy_efectivo)}}</h5>
                                    </div>
                                </div>
                                <div class="col-2 mt-2 mb-4">
                                    <div>
                                        <p class="text-muted text-truncate mb-2">
                                            Total GetNet
                                        </p>
                                        <h5 class="mb-0">{{formatNumber(datos_hoy.totalVentasHoy_getnet)}}</h5>
                                    </div>
                                </div>
                                <div class="col-2 mt-2 mb-4">
                                    <div>
                                        <p class="text-muted text-truncate mb-2">
                                            Total Pago Online
                                        </p>
                                        <h5 class="mb-0">{{formatNumber(datos_hoy.totalVentasHoy_online)}}</h5>
                                    </div>
                                </div> 
                                <div class="col-2 mt-2 mb-4">
                                    <div>
                                        <p class="text-muted text-truncate mb-2">
                                            Total Transferencia
                                        </p>
                                        <h5 class="mb-0">{{formatNumber(datos_hoy.totalVentasHoy_transferencia)}}</h5>
                                    </div>
                                </div>
                                <div class="col-2 mt-2 mb-4">
                                    <div>
                                        <p class="text-muted text-truncate mb-2">
                                            Total Edenred
                                        </p>
                                        <h5 class="mb-0">{{formatNumber(datos_hoy.totalVentasHoy_edenred)}}</h5>
                                    </div>
                                </div>
                                <div class="col-2 mt-2 mb-4">
                                    <div>
                                        <p class="text-muted text-truncate mb-2">
                                            Total amiPASS
                                        </p>
                                        <h5 class="mb-0">{{formatNumber(datos_hoy.totalVentasHoy_amipass)}}</h5>
                                    </div>
                                </div>
                                <div class="col-2 mt-2 mb-4">
                                    <div>
                                        <p class="text-muted text-truncate mb-2">
                                            Venta total
                                        </p>
                                        <h5 class="mb-0">{{formatNumber(datos_hoy.totalVentasHoy)}}</h5>
                                    </div>
                                </div>
                            </div>
                            <h5 class="m-4 text-lg-left">Métricas ventas de ayer</h5>
                            <div class="row">
                                <div class="col-2 mt-2 mb-2">
                                    <div>
                                        <p class="text-muted text-truncate">
                                            Total Waffles
                                        </p>
                                        <h4 class="bx bxs-badge" style="color: #EECC93;"></h4>
                                        <h5 class="mb-0">{{ Math.abs(tipos[0].ventasAyer) }}</h5>
                                    </div>
                                </div>
                                <div class="col-2 mt-2 mb-2">
                                    <div>
                                        <p class="text-muted text-truncate">
                                            Total Completos
                                        </p>
                                        <h4 class="fas fa-hotdog" style="color: #DEB887;"></h4>
                                        <h5 class="mb-0">{{ Math.abs(tipos[1].ventasAyer) }}</h5>
                                    </div>
                                </div>
                                <div class="col-2 mt-2 mb-2">
                                    <div>
                                        <p class="text-muted text-truncate">
                                            Total Cafe
                                        </p>
                                        <h4 class="fas fa-coffee" style="color: brown;"></h4>
                                        <h5 class="mb-0">{{ Math.abs(tipos[4].ventasAyer) }}</h5>
                                    </div>
                                </div>
                            </div>
                            <h5 class="m-4 text-lg-left" v-if="user.rol=='Admin'">Flujo de caja de ayer</h5>
                            <div class="row" v-if="user.rol=='Admin'">
                                <div class="col-2 mt-2 mb-4">
                                    <div>
                                        <p class="text-muted text-truncate mb-2">
                                            Total Efectivo
                                        </p>
                                        <h5 class="mb-0">{{formatNumber(datos_hoy.totalVentasAyer_efectivo)}}</h5>
                                    </div>
                                </div>
                                <div class="col-2 mt-2 mb-4">
                                    <div>
                                        <p class="text-muted text-truncate mb-2">
                                            Total GetNet
                                        </p>
                                        <h5 class="mb-0">{{formatNumber(datos_hoy.totalVentasAyer_getnet)}}</h5>
                                    </div>
                                </div>
                                <div class="col-2 mt-2 mb-4">
                                    <div>
                                        <p class="text-muted text-truncate mb-2">
                                            Total Pago Online
                                        </p>
                                        <h5 class="mb-0">{{formatNumber(datos_hoy.totalVentasAyer_online)}}</h5>
                                    </div>
                                </div> 
                                <div class="col-2 mt-2 mb-4">
                                    <div>
                                        <p class="text-muted text-truncate mb-2">
                                            Total Transferencia
                                        </p>
                                        <h5 class="mb-0">{{formatNumber(datos_hoy.totalVentasAyer_transferencia)}}</h5>
                                    </div>
                                </div>
                                <div class="col-2 mt-2 mb-4">
                                    <div>
                                        <p class="text-muted text-truncate mb-2">
                                            Total Edenred
                                        </p>
                                        <h5 class="mb-0">{{formatNumber(datos_hoy.totalVentasAyer_edenred)}}</h5>
                                    </div>
                                </div>
                                <div class="col-2 mt-2 mb-4">
                                    <div>
                                        <p class="text-muted text-truncate mb-2">
                                            Total amiPASS
                                        </p>
                                        <h5 class="mb-0">{{formatNumber(datos_hoy.totalVentasAyer_amipass)}}</h5>
                                    </div>
                                </div>
                                <div class="col-2 mt-2 mb-4">
                                    <div>
                                        <p class="text-muted text-truncate mb-2">
                                            Venta total
                                        </p>
                                        <h5 class="mb-0">{{formatNumber(datos_hoy.totalVentasAyer)}}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>  
                </div>-->
                <b-modal ref="modal_egreso" id="modal_egreso" hide-footer header-bg-variant="primary">
                    <template #modal-header="{ close }">
                        <div class="d-flex justify-content-between align-items-center w-100">
                            <h5 class="text-white m-0">Egresos</h5>
                            <b-button class="text-white p-0" size="sm" variant="none" @click="close()">
                                <i class="bx bx-x font-size-16"></i>
                            </b-button>
                        </div>
                    </template>
                    <div class="row">
                        <div class="col-md-12 col-lg-12 col-xl-12">
                            <div class="card p-2 mb-2">
                                <div class="p-0 m-0">
                                    <div class="form-group row p-2 pl-3 mb-3">
                                        <div class="col-md-12">
                                            <b-form-group id="input-group-1" label="Detalle de egreso*" label-for="input-1">
                                                <b-form-textarea name="" id="" cols="3" rows="7" v-model="egreso.detalle" class="w-100 mb-0"
                                                ></b-form-textarea>
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-6">
                                            <b-form-group label="Categoría">
                                                <b-form-select v-model="egreso.tipo_egreso" :options="tipo_egreso" class="w-100"
                                                ></b-form-select>
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-6">
                                            <b-form-group id="input-group-1" label="Valor Total*" label-for="input-1">
                                                <b-form-input v-model="egreso.egreso" @input="handleMontoEgresoInput('egreso')" @focus="handleMontoEgresoFocus('egreso')" @blur="handleMontoEgresoBlur('egreso')" inputmode="numeric" class="w-100 mb-0"
                                                ></b-form-input>
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-12 mt-3">
                                            <button class="btn btn-primary"
                                                @click="gardar_egreso()"
                                                :disabled="disabledButton">
                                                Confirmar egreso
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-modal>                 
                
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="offset-md-3 col-md-3">
                                <b-button variant="primary" block @click="abrir_modal('modal_pedido')">Venta</b-button>
                            </div>
                            <div class="col-md-3">
                                <b-button variant="primary" block @click="abrir_modal('modal_egreso')">Egreso</b-button>
                            </div>
                        </div>
                    </div>
                </div>
                <br>
                <div class="card">
                    <div class="card-body">
                        <b-form-group>
                            <b-form-checkbox id="valor_editar_dip"
                                name="valor_editar_dip" v-model="mostrar_todos" @change="cambia_mostrar">
                                Mostrar/Ocultar Entregados y Cancelados
                            </b-form-checkbox>
                        </b-form-group>
                        <!-- <div class="col-12">
                            <button class="btn btn-primary float-right mb-4" @click="abrir_modal('modal_pedido')">Crear Pedido</button>
                        </div> -->
                        <div class="table-responsive">
                            <table class="table project-list-table table-nowrap table-centered table-borderless">
                                <thead>
                                    <tr>
                                        <th scope="col" style="width: 100px">ID</th>
                                        <th scope="col">Nombre</th>
                                        <th scope="col">Fecha y Hora</th>
                                        <th scope="col">Canal / Estado</th>
                                        <!--<th scope="col">Acciones</th>-->
                                        <th scope="col">Total</th>
                                        <th scope="col">Opciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="pedido in pedidos" :key="pedido.id">
                                        <td>{{ pedido.id }}</td>
                                        <td>
                                            {{ pedido.nombre != null ? pedido.nombre : '' }}
                                        </td>
                                        <td>{{ formattedDate(pedido.created_at) }}</td>
                                        <td>
                                            <p class="badge" 
                                            :class="{
                                                'badge-local': `${pedido.canal_id}` == 1, 
                                                'badge-pedidos': `${pedido.canal_id}` == 2, 
                                                'badge-uber': `${pedido.canal_id}` == 4, 
                                                'badge-wsp': `${pedido.canal_id}` == 5
                                            }" 
                                            style="display: inline-block;">
                                            {{ pedido.canal_id != null ? canales.find(c=>c.id==pedido.canal_id).name : '' }}
                                            </p>
                                            <span><b>/</b></span>
                                            <p class="badge" 
                                            :class="{
                                                'badge-success': `${pedido.estado}` == 'Entregado',
                                                'badge-info': `${pedido.estado}` == 'Pagado',
                                                'badge-warning': `${pedido.estado}` == 'Creado',
                                                'badge-danger': `${pedido.estado}` == 'Cancelado'
                                            }" 
                                            style="display: inline-block;">
                                            {{ pedido.estado }}
                                            </p>
                                        </td>

                                       <!-- <td>
                                            
                                            <button class="btn btn-success btn-sm py-1 px-2" title="Marcar como Pagado"
                                                v-if="pedido.estado == 'Creado'" @click="ver_payment_modal(pedido)"><i
                                                    class="fas fa-dollar-sign"></i> </button>
                                             <button class="btn btn-danger btn-sm py-1 px-2"
                                                title="Marcar como Cancelado" v-if="pedido.estado == 'Creado'"
                                                @click="pedido_cancelado(pedido)"><i class="fas fa-ban"></i> </button> 
                                            <button class="btn btn-success btn-sm py-1 px-2"
                                                title="Marcar como Entregado" v-if="pedido.estado == 'Pagado'"
                                                @click="pedido_finalizado(pedido)"> <i class="bx bxs-shopping-bag"></i>
                                            </button>
                                            
                                        </td>
                                    -->
                                        <td>{{ formatNumber(parseInt(pedido.venta)) }}</td>
                                        <td>
                                            <!-- Botón con el icono de ojo para ver detalles del pedido -->
                                            <button class="btn btn-link p-0" title="Ver pedido" @click="ver_pedido_detalle(pedido)">
                                                <i class="mdi mdi-eye font-size-18"></i>
                                            </button>
                                            <button class="btn btn-link p-0" title="Ver pedido" @click="ver_modal_impresora(pedido)">
                                                <i class="mdi mdi-printer font-size-18"></i>
                                            </button>
                                                <button class="btn btn-link p-0"
                                                    title="Marcar como Cancelado" 
                                                    v-if="pedido.estado == 'Creado' || user.rol=='Admin'"
                                                    @click="pedido_cancelado(pedido)">
                                                <i class="fas fa-trash"></i> <!-- Cambiado a icono de basurero -->
                                            </button>
                                            <button class="btn btn-success btn-sm py-1 px-2" title="Marcar como Pagado"
                                                v-if="pedido.estado == 'Creado'" @click="ver_payment_modal(pedido)"><i
                                                    class="fas fa-dollar-sign"></i> </button>
                                            <!-- <button class="btn btn-danger btn-sm py-1 px-2"
                                                title="Marcar como Cancelado" v-if="pedido.estado == 'Creado'"
                                                @click="pedido_cancelado(pedido)"><i class="fas fa-ban"></i> </button> -->
                                            <button class="btn btn-success btn-sm py-1 px-2"
                                                title="Marcar como Entregado" v-if="pedido.estado == 'Pagado'"
                                                @click="pedido_finalizado(pedido)"> <i class="bx bxs-shopping-bag"></i>
                                            </button>
                                        </td>
                                        <!-- <td>
                                            <b-dropdown class="card-drop" variant="white" bottom toggle-class="p-0">
                                                <template v-slot:button-content>
                                                    <i class="mdi mdi-eye font-size-18"></i>
                                                </template>
                                                <b-dropdown-item @click="ver_pedido_detalle(pedido)">Ver Pedido</b-dropdown-item>
                                            </b-dropdown>
                                        </td> -->
                                    </tr>
                                </tbody>
                            </table>
                            <b-modal ref="modal_egreso" id="modal_egreso" hide-footer header-bg-variant="primary">
                                <template #modal-header="{ close }">
                                    <div class="d-flex justify-content-between align-items-center w-100">
                                        <h5 class="text-white m-0">Egresos</h5>
                                        <b-button class="text-white p-0" size="sm" variant="none" @click="close()">
                                            <i class="bx bx-x font-size-16"></i>
                                        </b-button>
                                    </div>
                                </template>
                                <div class="row">
                                    <div class="col-md-12 col-lg-12 col-xl-12">
                                        <div class="card p-2 mb-2">
                                            <div class="p-0 m-0">
                                                <div class="form-group row p-2 pl-3 mb-3">
                                                    <div class="col-md-12">
                                                        <b-form-group id="input-group-1" label="Detalle de egreso*" label-for="input-1">
                                                            <b-form-textarea name="" id="" cols="3" rows="7" v-model="egreso.detalle" class="w-100 mb-0"
                                                            ></b-form-textarea>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <b-form-group label="Categoría">
                                                            <b-form-select v-model="egreso.tipo_egreso" :options="tipo_egreso" class="w-100"
                                                            ></b-form-select>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <b-form-group id="input-group-1" label="Valor Total*" label-for="input-1">
                                                            <b-form-input v-model="egreso.egreso" @input="handleMontoEgresoInput('egreso')" @focus="handleMontoEgresoFocus('egreso')" @blur="handleMontoEgresoBlur('egreso')" inputmode="numeric" class="w-100 mb-0"
                                                            ></b-form-input>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-12 mt-3">
                                                        <button class="btn btn-primary"
                                                            @click="gardar_egreso()" :disabled="disabledButton">
                                                            Confirmar egreso
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-modal>
                            <b-modal id="payment_modal" ref="payment_modal"
                                @ok="submitPayment" hide-footer header-bg-variant="primary">
                                <template #modal-header="{ close }">
                                    <div class="d-flex justify-content-between align-items-center w-100">
                                        <!-- Título del modal -->
                                        <h5 class="text-white mt-2">Información de Pago</h5>
                                        <!-- Botón de cierre -->
                                        <b-button class="text-white p-0" size="sm" variant="none" @click="close()">
                                        <i class="bx bx-x font-size-16"></i>
                                        </b-button>
                                    </div>
                                </template>
                                <!-- Selección del tipo de pago -->
                                <h5>Valor Venta: {{ formatNumber(parseInt(pedido_detalle.venta)) }}</h5>
                                <b-form-group class="mt-4" label="Seleccionar tipo de Pago:" label-for="paymentType">
                                    <b-button-group class="w-100 d-flex">
                                        <b-button
                                            :variant="pedido_detalle.paymentType === 'total' ? 'primary' : 'secondary'"
                                            class="flex-fill"
                                            @click="seleccionarTipoPago('total')">
                                            Total
                                        </b-button>
                                        <b-button
                                            :variant="pedido_detalle.paymentType === 'dividido' ? 'primary' : 'secondary'"
                                            class="flex-fill"
                                            @click="seleccionarTipoPago('dividido')">
                                            Dividido
                                        </b-button>
                                    </b-button-group>
                                </b-form-group>

                                <!-- Método de pago (solo si es Total) -->
                                <b-form-group v-if="pedido_detalle.paymentType === 'total'" label="Método de Pago"
                                    label-for="paymentMethod">
                                    <div class="d-flex flex-wrap" style="gap: 0.5rem;">
                                        <b-button
                                            v-if="pedido_detalle.canal_id!=2"
                                            :variant="pedido_detalle.paymentMethod === 'Debito' ? 'primary' : 'secondary'"
                                            @click="seleccionarMetodoPago('Debito')">Débito</b-button>
                                        <b-button
                                            v-if="pedido_detalle.canal_id!=2"
                                            :variant="pedido_detalle.paymentMethod === 'Credito' ? 'primary' : 'secondary'"
                                            @click="seleccionarMetodoPago('Credito')">Crédito</b-button>
                                        <b-button
                                            :variant="pedido_detalle.paymentMethod === 'Efectivo' ? 'primary' : 'secondary'"
                                            @click="seleccionarMetodoPago('Efectivo')">Efectivo</b-button>
                                        <b-button
                                            v-if="pedido_detalle.canal_id!=2"
                                            :variant="pedido_detalle.paymentMethod === 'Transferencia' ? 'primary' : 'secondary'"
                                            @click="seleccionarMetodoPago('Transferencia')">Transferencia</b-button>
                                        <b-button
                                            v-if="pedido_detalle.canal_id!=2"
                                            :variant="pedido_detalle.paymentMethod === 'Edenred' ? 'primary' : 'secondary'"
                                            @click="seleccionarMetodoPago('Edenred')">Edenred</b-button>
                                        <b-button
                                            v-if="pedido_detalle.canal_id!=2"
                                            :variant="pedido_detalle.paymentMethod === 'amipos' ? 'primary' : 'secondary'"
                                            @click="seleccionarMetodoPago('amipos')">amipos</b-button>
                                    </div>
                                </b-form-group>

                                <!-- Detalles de pago (solo si es Dividido) -->
                                <div v-if="pedido_detalle.paymentType === 'dividido'">
                                    <!-- <b-form-group label="Detalles del Pago Dividido">
                                        <b-form-checkbox v-model="pedido_detalle.useGetNet">GetNet</b-form-checkbox>
                                        <b-form-checkbox v-model="pedido_detalle.useEfectivo">Efectivo</b-form-checkbox>
                                        <b-form-checkbox v-model="pedido_detalle.useTransferencia">Transfencia</b-form-checkbox>
                                        <b-form-checkbox v-model="pedido_detalle.useJunaeb">Junaeb</b-form-checkbox>
                                    </b-form-group> -->

                                    <!-- Input para Transbank -->
                                    <b-form-group label="Monto con Débito">
                                        <b-form-input v-model="getnetAmount" type="number"
                                            placeholder="Ingrese el monto a pagar con Débito" :min='0'></b-form-input>
                                    </b-form-group>

                                    <b-form-group label="Monto con Crédito">
                                        <b-form-input v-model="onlineAmount" type="number"
                                            placeholder="Ingrese el monto a pagar con Crédito" :min='0'></b-form-input>
                                    </b-form-group>

                                    <!-- Input para Efectivo -->
                                    <b-form-group label="Monto en Efectivo">
                                        <b-form-input v-model="efectivoAmount" type="number"
                                            placeholder="Ingrese el monto a pagar en Efectivo" :min='0' ></b-form-input>
                                    </b-form-group>
                                    <!-- Input para Transferencia -->
                                    <b-form-group label="Monto en Transferencia">
                                        <b-form-input v-model="transferenciaAmount" type="number"
                                            placeholder="Ingrese el monto a pagar en Transferencia" :min='0' ></b-form-input>
                                    </b-form-group>
                                    <!-- Input para Junaeb
                                    <b-form-group label="Monto en Junaeb">
                                        <b-form-input v-model="junaebAmount" type="number"
                                            placeholder="Ingrese el monto a pagar en Junaeb" :min='0' ></b-form-input>
                                    </b-form-group>
                                    -->
                                    <!-- Input para Edenred -->
                                    <b-form-group label="Monto en Edenred">
                                        <b-form-input v-model="edenredAmount" type="number"
                                            placeholder="Ingrese el monto a pagar en Edenred" :min='0' ></b-form-input>
                                    </b-form-group>
                                     <!-- Input para Amipass -->
                                     <b-form-group label="Monto en Amipass">
                                        <b-form-input v-model="amipassAmount" type="number"
                                            placeholder="Ingrese el monto a pagar en Amipass" :min='0' ></b-form-input>
                                    </b-form-group>
                                    <p v-if="pedido_detalle.paymentType === 'dividido' && parseInt(Valor_restante)<0" >Restante: {{ formatNumber(Valor_restante) }}</p>
                                    <p v-if="pedido_detalle.paymentType === 'dividido' && parseInt(Valor_restante)>0" >Exedente pago: {{ formatNumber(Valor_restante) }}</p>
                                </div>
                                <div class="text-right mt-4" v-if="pedido_detalle.paymentType=='total'">
                                    <button class="btn btn-success btn-sm py-1 px-2" title="Marcar como pagado"
                                                @click="pedido_pagado(pedido_detalle)" :disabled="!pedido_detalle.paymentMethod"> Guardar Pago
                                            </button>
                                </div>
                                <div class="text-right mt-4" v-if="pedido_detalle.paymentType=='dividido'">
                                    <button class="btn btn-success btn-sm py-1 px-2" title="Marcar como pagado" 
                                    :disabled="parseInt(Valor_restante) != 0 "
                                                @click="pedido_pagado(pedido_detalle)"> Guardar Pago
                                            </button>
                                </div>
                            </b-modal>
                            <b-modal id="pedido_detalle" ref="pedido_detalle" hide-footer header-bg-variant="primary">
                                <template #modal-header="{ close }">
                                    <div class="d-flex justify-content-between align-items-center w-100">
                                        <!-- Título del modal -->
                                        <h5 class="text-white mt-2">Detalle del Pedido {{ pedido_detalle.id }}</h5>
                                        <!-- Botón de cierre -->
                                        <b-button class="text-white p-0" size="sm" variant="none" @click="close()">
                                        <i class="bx bx-x font-size-16"></i>
                                        </b-button>
                                    </div>
                                </template>
                                <p>Canal: {{ pedido_detalle.canal_name }} - Turno: {{ pedido_detalle.turno_name }}</p>
                                <p>Creado: {{ formattedDate(pedido_detalle.creado_at) }}</p>
                                <p v-if="formattedDate(pedido_detalle.pagado_at)">
                                    Pagado: {{ formattedDate(pedido_detalle.pagado_at) }} ({{
                                    calculateTimeDifference(pedido_detalle.creado_at,
                                    pedido_detalle.pagado_at) }})
                                </p>
                                <p v-if="formattedDate(pedido_detalle.finalizado_at)">
                                    Entregado: {{ formattedDate(pedido_detalle.finalizado_at) }} ({{
                                    calculateTimeDifference(pedido_detalle.pagado_at, pedido_detalle.finalizado_at) }})
                                </p>
                                <b-table :items="pedido_detalle.productos" :fields="pedido_detalle_fields" bordered striped>
                                    <template #cell(pivot.cantidad)="data">
                                        {{ formatearCantidadConUnidad(data.item.pivot.cantidad, data.item) }}
                                    </template>
                                    <template #cell(pivot.venta)="data">
                                        <template v-if="debeMostrarSubtotalOriginalPivot(data.item)">
                                            <del>{{ formatNumber(Math.round(subtotalBasePivot(data.item))) }}</del>
                                            &nbsp;
                                            {{ formatNumber(Math.round(data.item.pivot.venta)) }}
                                        </template>
                                        <template v-else>
                                            {{ formatNumber(Math.round(data.item.pivot.venta)) }}
                                        </template>
                                    </template>
                                    <template #cell(ingredientes_modificados)="data">
                                        {{ articulos.filter(ingrediente => JSON.parse(data.item.pivot.ingredientes_modificados).includes(ingrediente.id)).map(ingrediente => ingrediente.name).join(', ') }}
                                    </template>
                                    <template #cell(ingredientes_agregados)="data">
                                        {{ articulos.filter(ingrediente => JSON.parse(data.item.pivot.ingredientes_agregados).includes(ingrediente.id)).map(ingrediente => ingrediente.name).join(', ') }}
                                    </template>
                                </b-table>
                                
                                <div v-if="pedido_detalle.comentario != ''">
                                    <label for="">Comentarios Generales</label>
                                    <p>{{ pedido_detalle.comentario }}</p>
                                </div>
                                <div v-else>
                                    <label for="">Sin Comentarios</label>
                                </div>
                            </b-modal>
                            <b-modal id="modal_pedido" ref="modal_pedido" hide-footer header-bg-variant="primary">
                                <template #modal-header="{ close }">
                                    <div class="d-flex justify-content-between align-items-center w-100">
                                        <!-- Título del modal -->
                                        <h5 class="text-white m-0">Nuevo Pedido</h5>
                                        <!-- Botón de cierre -->
                                        <b-button class="text-white p-0" size="sm" variant="none" @click="close()">
                                        <i class="bx bx-x font-size-16"></i>
                                        </b-button>
                                    </div>
                                </template>
                                <div class="row">
                                    <div class="col-md-12 col-lg-12 col-xl-12">
                                        <div class="card p-2 mb-2">
                                            <div class="p-0 m-0">
                                                <div class="row p-0 m-0">
                                                    <b-form-group id="input-group-2" label="Turno" label-for="input-2" class="col-md-6">
                                                        <b-button-group>
                                                            <b-button 
                                                            v-for="(turno, i) in turnos" 
                                                            :key="i" 
                                                            :variant="turno.id === pedido.turno_id ? 'primary' : 'secondary'"
                                                            @click="pedido.turno_id = turno.id">
                                                            {{ turno.name }}
                                                            </b-button>
                                                        </b-button-group>
                                                    </b-form-group>
                                                </div>
                                            </div>
                                            <div class="row p-0 m-0">
                                                <b-form-group id="input-group-1" label="Canal" label-for="input-1" class="col-md-6">
                                                    <b-button-group>
                                                        <b-button 
                                                            v-for="(canal, i) in canales" 
                                                            :key="i" 
                                                            :variant="canal.id === pedido.canal_id ? 'primary' : 'secondary'"
                                                            @click="selectCanal(canal)">
                                                            {{ canal.name }}
                                                        </b-button>
                                                    </b-button-group>
                                                </b-form-group>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 col-lg-12 col-xl-12">
                                        <div class="card p-2 mb-2">
                                            <div class="p-0 m-0">
                                                <b-form-group id="input-group-1" label="Agregar Promocion o Producto" label-for="input-1" class="col-md-12">
                                                    <multiselect v-if="productos_porcanal"
                                                        v-model="detalle.producto"
                                                        :options="productos_porcanal"
                                                        :custom-label="labelselect_cat" 
                                                        placeholder="Selecciona un producto" 
                                                        selectLabel="Presiona para seleccionar"
                                                        selectedLabel="Seleccionado"
                                                        deselectLabel="Presiona para remover"
                                                        track-by="nombre"
                                                        :searchable="true"
                                                        :filterable="true"
                                                        @select="onSelect"
                                                        @keydown.native.enter="onEnterSelect"
                                                        >
                                                        <template v-slot:noOptions>
                                                            <p>No hay opciones</p>
                                                        </template>
                                                        <template v-slot:noResult>
                                                            <p>No se encuentra coincidencia</p>
                                                        </template>
                                                    </multiselect>
                                                    <!--<select class="custom-select" v-model="detalle.producto">
                                                        <option value="">Selecciona un producto</option>
                                                        <option v-for="(producto, i) in productos.filter(p=> 
                                                                (p.disponible=='1' && p.local=='1' && this.pedido.canal.name=='Local') || 
                                                                (p.disponible=='1' && p.pedidosYa=='1' && this.pedido.canal.name=='PedidosYa')|| 
                                                                (p.disponible=='1' && p.WhatsApp=='1' && this.pedido.canal.name=='WhatsApp')|| 
                                                                (p.disponible=='1' && p.UberEats=='1' && this.pedido.canal.name=='UberEats'))"
                                                            :label="producto.name" :value="producto" :key="i">
                                                        </option>
                                                    </select>-->
                                                </b-form-group>
                                                <div class="form-group row p-2 pl-3 mb-3" v-if="detalle.producto">
                                                    <div class="col-md-3">
                                                        <b-form-input id="input-1" ref="inputCantidadDetalle" type="number" v-model.number="detalle.cantidad" :min="detalleCantidadMinima" :max="maxCantidadProductoActual" :step="detalleCantidadStep" size="sm" @focus="limpiarCantidadDetalle" @input="normalizarCantidadDetalleInput" @blur="restaurarCantidadDetalle"></b-form-input>
                                                    </div>
                                                    <div class="col-md-9">
                                                        <p>{{ nombre_medida(detalle.producto.articulos[0]) }}</p>
                                                        <small class="text-muted" v-if="maxCantidadProductoActual !== undefined">
                                                            Stock disponible: {{ maxCantidadProductoActual }}
                                                        </small>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <b-form-group id="input-group-1" label="Agregar Comentario" label-for="input-1">
                                                            <b-form-textarea
                                                                name=""
                                                                id=""
                                                                cols="3"
                                                                rows="3"
                                                                v-model="detalle.comentario"
                                                                class="w-100 mb-0"
                                                            ></b-form-textarea>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-12 text-right mt-0">
                                                        <div id="input-group-1" label-cols-sm="12" label-cols-lg="12">
                                                            <div class="d-flex flex-column">
                                                            <!-- Texto del Valor -->
                                                            <div class="mb-1 p-0">
                                                                <h4>Valor: {{ formatNumber(calcula_valor()) }}</h4>
                                                            </div>
                                                            <!-- Input para editar valor (visible solo si editar_valor es true) -->
                                                            <b-form-input
                                                                id="input-1"
                                                                name="valor"
                                                                v-model="detalle.venta"
                                                                type="number"
                                                                :min="1"
                                                                v-if="editar_valor"
                                                                :placeholder="calcula_valor().toString()"
                                                                class="mb-2"
                                                            ></b-form-input>
                                                            <!-- Checkbox -->
                                                            <b-form-checkbox v-model="editar_valor" class="mb-2">
                                                                Modificar precio
                                                            </b-form-checkbox>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-12 mb-2 text-right">
                                                        <button class="btn btn-success btn-block btn-sm" :disabled="(parseFloat(detalle.cantidad) || 0) <= 0 || (editar_valor && (detalle.venta < 0 || detalle.venta == '')) "
                                                            @click="agregar_producto()">Agregar al pedido</button>
                                                    </div>
                                                    <div class="col-md-12 text-right">
                                                        <button class="btn btn-danger btn-block btn-sm"
                                                            @click="cancelar_producto()">Eliminar</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card p-2" v-if="pedido.detalle.length > 0">
                                            <div class="p-0 m-0">
                                                <div class="table-responsive">
                                                    <table class="table table-centered mb-0 table-nowrap">
                                                        <thead class="thead-light text-center">
                                                            <tr>
                                                                <th>Producto</th>
                                                                <th>Valor</th>
                                                                <th>Cantidad</th>
                                                                <th>SubTotal</th>
                                                                <th>Acción</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody class="text-center">
                                                            <tr v-for="(item, index) in pedido.detalle" :key="index">
                                                                <td>{{ item.producto.name }}</td>
                                                                <td>
                                                                    {{ formatNumber(parseInt(item.producto.venta)) }}
                                                                    <small v-if="unidadPrecioProducto(item.producto)">/ {{ unidadPrecioProducto(item.producto) }}</small>
                                                                </td>
                                                                <td>
                                                                    {{ formatearCantidadConUnidad(item.cantidad, item.producto) }}
                                                                </td>
                                                                <td>
                                                                    <span v-if="debeMostrarSubtotalOriginal(item)">
                                                                        <s>{{ formatNumber(Math.round(item.subtotal_real || subtotalBaseItem(item))) }}</s>
                                                                        <span>{{ formatNumber(parseInt(item.venta)) }}</span>     <!-- Muestra el valor final -->
                                                                    </span>
                                                                    <span v-else>
                                                                        {{ formatNumber(parseInt(item.venta)) }} <!-- Muestra el valor normalmente si no hay diferencia -->
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <b-button size="sm" variant="danger"
                                                                        @click="quitar_producto_de_pedido(item, index)">
                                                                        <i class="mdi mdi-trash-can font-size-14"></i></b-button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="row p-2">
                                                    <p class="col-md-12 text-right"><b>Total: {{ formatNumber(pedido.venta) }}</b>
                                                    </p>
                                                    <div class="col-md-12" v-if="pedido.detalle.length">
                                                        <button class="btn btn-primary btn-block btn-sm py-2 px-4 d-flex align-items-center justify-content-center"
                                                                :disabled="detalle.producto != ''"
                                                                @click="confirmar_pedido()">
                                                            <!-- Estrella antes del texto -->
                                                            <span class="mdi mdi-star mr-2" style="color: gold;"></span>
                                                            <!-- Texto -->
                                                            Confirmar Pedido
                                                            <!-- Estrella después del texto -->
                                                            <span class="mdi mdi-star ml-2" style="color: gold;"></span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-modal>
                            <b-modal id="modal_imresora" ref="modal_imresora" hide-header hide-footer>
                                <div>
                                    <!-- <button @click="imprimir" class="btn btn-primary">Imprimir</button> -->
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title">Detalles del Pedido</h5>
                                        </div>
                                        <div class="modal-body" ref="contenidoPedido">
                                            <!-- Aquí mostrarás los detalles del pedido que se va a imprimir -->
                                            <p><strong>Pedido #:</strong> {{ pedidoSeleccionado.id }} - {{ extraerHora(pedidoSeleccionado.creado_at) }}</p>
                                            <p><strong>Nombre:</strong> {{ pedidoSeleccionado.nombre }}</p>
                                            <p><strong>Canal:</strong> {{ pedidoSeleccionado.canal_name}}</p>
                                            <p><strong>Productos:</strong></p>
                                            <ul>
                                                <li v-for="producto in pedidoSeleccionado.productos" :key="producto.id">
                                                    <strong>{{ producto.pivot.cantidad }} </strong> - {{ producto.name }}
                                                    <span v-if="producto.pivot.comentario!=''">
                                                        <br />
                                                        <strong> - {{ producto.pivot.comentario }}</strong>
                                                    </span>
                                                </li>
                                            </ul>
                                            <p><strong>Total:</strong> {{ pedidoSeleccionado.venta }}</p>
                                            <p v-if="pedidoSeleccionado.comentario!=''"><strong>Notas: {{ pedidoSeleccionado.comentario }} </strong></p>
                                        </div>
                                    </div>
                                </div>
                            </b-modal>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
<style>
.logo-img {
  filter: brightness(0) invert(1); /* Cambia el gris a negro */
}
.error-message {
    color: red;
}
.badge-local{
    background-color:black;
    color: white;
}
.badge-pedidos{
    background-color:red;
    color: white;
}
.badge-uber{
    background-color:rgb(3, 167, 50);
    color: white;
}
.badge-wsp{
    background-color:rgb(2, 224, 31);
    color: white;
}
</style>